export default {
  ND_PKT_SIZE_LENGTH: 5,
  ND_PKT_SIZE_COMMAND: 4,

  ND_PKT_OFFSET_LENGTH: 0,
  ND_PKT_OFFSET_COMMAND: 5,

  /* CTI -> TSAPI로 전송되는 커맨드 */
  ND_CMD: 100,
  ND_CMD_MONITOR_DEVICE: 101,
  ND_CMD_MONITOR_CALL: 102,
  ND_CMD_MONITOR_CALLS_VIA: 103,
  ND_CMD_ROUTE_REGISTER_REQ: 104,
  ND_CMD_CHG_MONITOR_FILTER: 105,
  ND_CMD_MONITOR_ENDED: 106,
  ND_CMD_SET_AGENT_STATE: 107,
  ND_CMD_SET_MWI: 108,
  ND_CMD_SET_DND: 109,
  ND_CMD_SET_FWD: 110,
  ND_CMD_QUERY_MWI: 111,
  ND_CMD_QUERY_DND: 112,
  ND_CMD_QUERY_FWD: 113,
  ND_CMD_QUERY_AGENT_STATE: 114,
  ND_CMD_QUERY_LAST_NUMBER: 115,
  ND_CMD_QUERY_DEVICE_INFO: 116,
  ND_CMD_MAKE_CALL: 117,
  ND_CMD_MAKE_PREDICTIVE_CALL: 118,
  ND_CMD_ANSWER_CALL: 119,
  ND_CMD_CALL_COMPLETION: 120,
  ND_CMD_CLEAR_CALL: 121,
  ND_CMD_CLEAR_CONNECTION: 122,
  ND_CMD_HOLD_CALL: 123,
  ND_CMD_RETRIEVE_CALL: 124,
  ND_CMD_CONSULTATION_CALL: 125,
  ND_CMD_RECONNECT_CALL: 126,
  ND_CMD_ALTERNATE_CALL: 127,
  ND_CMD_TRANSFER_CALL: 128,
  ND_CMD_CONFERENCE_CALL: 129,
  ND_CMD_DEFLECT_CALL: 130,
  ND_CMD_ROUTE_SELECT_REQUEST: 131,
  ND_CMD_SINGLE_STEP_TRANSFER: 132,
  ND_CMD_PICKUP_CALL: 133,
  ND_CMD_GROUP_PICKUP_CALL: 134,
  ND_CMD_SEND_DTMF: 135,
  ND_CMD_ESCAPE_SERVICE: 136,
  ND_CMD_MESSAGE: 137,
  ND_CMD_CHATDISCONNECT: 138,
  ND_CMD_SET_MUTE: 139,

  ND_CMD_CONF_CLEAR_CALL2: 141,

  /* TSAPI -> CTI로 전송되는 이벤트 */
  ND_EVT: 200,
  ND_EVT_MONITOR_DEVICE: 201, // 현재 디바이스 모니터링 시작
  ND_EVT_ROUTE_REGISTER_REQ: 202,
  ND_EVT_CHG_MONITOR: 203,
  ND_EVT_MONITOR_ENDED: 204, // 현재 디바이스 모니터링 종료
  ND_EVT_LOGGED_ON: 205,
  ND_EVT_LOGGED_OFF: 206,
  ND_EVT_NOT_READY: 207,
  ND_EVT_READY: 208,
  ND_EVT_WORK_NOT_READY: 209,
  ND_EVT_WORK_READY: 210,
  ND_EVT_MESSAGE_WAITING: 211,
  ND_EVT_DO_NOT_DISTURB: 212,
  ND_EVT_FORWARDING: 213,
  ND_EVT_QUERY_MWI: 214,
  ND_EVT_QUERY_DND: 215,
  ND_EVT_QUERY_FWD: 216,
  ND_EVT_QUERY_AGENT_STATE: 217, // 상담원 상태가 변경될시 발생하는 이벤트
  // AGTstate : 0  -> 로그인, substate
  // AGTstate : 1  -> 로그아웃
  // AGTstate : 2  -> 대기
  ND_EVT_QUERY_LAST_NUMBER: 218,
  ND_EVT_QUERY_DEVICE_INFO: 219,
  ND_EVT_ROUTE_REQUEST: 220,
  ND_EVT_ROUTE_REQUEST_EXT: 221,
  ND_EVT_ROUTE_USE: 222,
  ND_EVT_ROUTE_USE_EXT: 223,
  ND_EVT_ROUTE_END: 224,
  ND_EVT_SERVICE_INITIATED: 225,
  ND_EVT_ORIGINATED: 226, // 호발생
  ND_EVT_DELIVERED: 227, // 링 이벤트
  ND_EVT_ESTABLISHED: 228, // 통화연결
  ND_EVT_CALL_CLEARED: 229,
  ND_EVT_CONNECTION_CLEARED: 230, // 통화 종료 (협의, 3자통화에서도 같은 이벤트가 온다.)
  ND_EVT_HELD: 231, // 보류
  ND_EVT_RETRIEVED: 232, // 보류상태에서 재통화
  ND_EVT_TRANSFERRED: 233, // 전환
  ND_EVT_CONFERENCED: 234, // 3자통화
  ND_EVT_QUEUED: 235,
  ND_EVT_DIVERTED: 236,
  ND_EVT_NETWORK_REACHED: 237,
  ND_EVT_CALL_INFORMATION: 238,
  ND_EVT_BACK_IN_SERVICE: 239,
  ND_EVT_OUT_OF_SERVICE: 240,
  ND_EVT_FAILED: 241,
  ND_EVT_UNIVERSAL_FAILURE: 242,
  ND_EVT_ESCAPE_SERVICE: 243,
  ND_EVT_CALL_RESULT: 244,
  ND_EVT_SCREENPOP: 245,
  ND_EVT_CHATDISCONNECT: 246,
  // ND_EVT_CALLID_CHANGE : ND_EVT + 47,
  ND_EVT_DELIVERED_UEI: 247,
  ND_EVT_CONFERENCED_IVR: 248,

  /* TSAPI -> CTI로 전송되는 에러 */
  ND_ERR: 300,
  ND_ERR_MONITOR_DEVICE: 301,
  ND_ERR_MONITOR_CALL: 302,
  ND_ERR_MONITOR_CALLS_VIA: 303,
  ND_ERR_ROUTE_REGISTER_REQ: 304,
  ND_ERR_CHG_MONITOR_FILTER: 305,
  ND_ERR_MONITOR_ENDED: 306,
  ND_ERR_SET_AGENT_STATE: 307,
  ND_ERR_SET_MWI: 308,
  ND_ERR_SET_DND: 309,
  ND_ERR_SET_FWD: 310,
  ND_ERR_QUERY_MWI: 311,
  ND_ERR_QUERY_DND: 312,
  ND_ERR_QUERY_FWD: 313,
  ND_ERR_QUERY_AGENT_STATE: 314,
  ND_ERR_QUERY_LAST_NUMBER: 315,
  ND_ERR_QUERY_DEVICE_INFO: 316,
  ND_ERR_MAKE_CALL: 317,
  ND_ERR_MAKE_PREDICTIVE_CALL: 318,
  ND_ERR_ANSWER_CALL: 319,
  ND_ERR_CALL_COMPLETION: 320,
  ND_ERR_CLEAR_CALL: 321,
  ND_ERR_CLEAR_CONNECTION: 322,
  ND_ERR_HOLD_CALL: 323,
  ND_ERR_RETRIEVE_CALL: 324,
  ND_ERR_CONSULTATION_CALL: 325,
  ND_ERR_RECONNECT_CALL: 326,
  ND_ERR_ALTERNATE_CALL: 327,
  ND_ERR_TRANSFER_CALL: 328,
  ND_ERR_CONFERENCE_CALL: 329,
  ND_ERR_DEFLECT_CALL: 330,
  ND_ERR_ROUTE_SELECT_REQUEST: 331,
  ND_ERR_SINGLE_SETP_TRANSFER: 332,
  ND_ERR_PICKUP_CALL: 333,
  ND_ERR_GROUP_PICKUP_CALL: 334,
  ND_ERR_SEND_DTMF: 335,
  ND_ERR_ESCAPE_SERVICE: 336,
  ND_EVT_MESSAGE: 337,
  ND_EVT_MSGXFER: 338,

  ND_PRI: 400,
  ND_PRI_CALLLOG: 401,
  ND_PRI_STATUSLOG: 402,
  ND_PRI_SERVICELOG: 403,
  ND_PRI_CALLBACK: 404,
  ND_PRI_CALLRESULT: 405,
  ND_PRI_PDSMAKECALL: 406,
  ND_PRI_ICDLIST: 407,
  ND_PRI_AGENTLIST: 408,
  ND_PRI_CHANGEFLAG: 409,
  ND_PRI_SUBSTATUS: 410,

  // 모빌리언스 추가
  ND_PRI_AGENT_STATUS: 420,
  ND_PRI_ICD_STATUS: 421,
  ND_PRI_CENTER_STATUS: 426,
  ND_PRI_DELETE: 432,
  ND_PRI_INSERT: 433,

  // 용산 UBASE 추가.
  ND_PRI_ICDSTATUS: 435,
  ND_PRI_AGENTLIST2: 436,
  // ND_PRI_AGENTSTATE: 437,
  ND_PRI_ICDSTATUS2: 438,
  ND_PRI_GROUP_AGENT_LIST: 439,

  // ND_PRI_GETPDSDATA: 411,
  // ND_PRI_ITICALL: 412,
  //
  // 20060421 For CR_Path
  // ND_PRI_AGTINFO: 413,
  // ND_PRI_ITAINFO: 414,
  // ND_PRI_ICDINFO: 415,
  // ND_PRI_AGTINFO_STATUS: 416,
  // ND_PRI_ITAINFO_STATUS: 417,
  // ND_PRI_ICDINFO_STATUS: 418,
  // ND_PRI_ITAINFO_BLD: 419,
  //
  // ND_PRI_AGT_REQUEST_REGIST: 421,
  // ND_PRI_AGT_REQUEST_CANCLE: 422,
  // ND_PRI_DEFLECT_REQUEST: 423,
  //
  // ND_PRI_AGENT_STATUS: 424,
  // ND_PRI_ICD_STATUS: 425,
  // ND_PRI_CENTER_STATUS: 426,
  // ND_PRI_AGENT_TASK: 427,
  //
  // ND_PRI_DELETE: 432,
  // ND_PRI_INSERT: 433,
  // ND_PRI_IVR_STATUS: 434,
  // ND_PRI_ICDQUECNT: 435,
  // ND_PRI_ICDAGTCNT: 436,
  //
  // ND_PRI_ICD_ASSIGN: 451,

  ND_PRI_SET_WORK_MODE: 452,
  ND_PRI_GROUP_AGENTLIST: 453,

  ND_REC_START: 461,
  ND_REC_END: 462,
  ND_REC_SAVE_KEY: 463,
  ND_REC_SAVE_CALLINFO: 464,
  ND_REC_INFO: 465,

  ND_PDS_SAVE_CALLRESULT: 471,

  ND_PRI_CONNECTEXE: 497,
  ND_PRI_LINKCHECK: 498,
  ND_PRI_LINKDOWN: 499,

  ND_MNG: 500,
  ND_MNG_INIINFO: 501,
  ND_MNG_ICDINFO: 502,
  ND_MNG_ITAINFO: 503,
  ND_MNG_AGENTINFO: 504,
  ND_MNG_LINEINFO: 505,
  ND_MNG_CAMPAIGNINFO: 506,
  ND_MNG_MONITORSTOP: 507,
  ND_MNG_WAITTIME: 508,
  ND_MNG_AGTSTATUS: 509,
  ND_MNG_LINEAGTALL: 510,
  ND_MNG_LINEAGTICD: 511,
  ND_MNG_IVRMONITOR: 512,
  ND_MNG_ITIMONITOR: 513,
  ND_MNG_PDSMONITOR: 514,
  ND_MNG_SELFMONITOR: 515,
  ND_MNG_PROCMONITOR: 516,
  ND_MNG_ICDMONITOR: 517,
  ND_MNG_LINEAGTGRP: 518,

  /* added For TR_MangerEx */
  ND_MNG_LINEAGTALLEX: 519,
  ND_MNG_IVRMONITOREX: 520,
  ND_MNG_IVRSTATICS: 521,
  ND_MNG_AGTSTATUSEX: 522,
  ND_MNG_ICDMONITOREX: 523,
  ND_MNG_GROUPINFO: 524,
  ND_MNG_ICDSTATICS: 525,
  ND_MNG_LINEAGTICDEX: 526,
  ND_MNG_AGTID_CLEAR: 527,
  ND_MNG_DN_CLEAR: 528,
  ND_MNG_NOTICE_GROUP: 529,
  ND_MNG_NOTICE_ICD: 530,

  ND_MNG_AGTPORT_REQ: 540,
  ND_MNG_IVRPORT_REQ: 541,

  ND_ITI: 600,
  ND_ITI_AGENTREQUEST: 601,
  ND_ITI_AGENTREQUESTED: 602,
  ND_ITI_AGENTINFO: 603,
  ND_ITI_REQUESTCANCLE: 604,
  ND_ITI_MSGONDEMAND: 605,
  ND_ITI_AGENTDISCONNECT: 609,
  ND_ITI_CLIENTDISCONNECT: 610,

  /* 전광판 모니터링 */
  ND_NTS: 700,
  ND_NTS_MONITORSTOP: 701,
  ND_NTS_CENTER_STATUS: 702,
  ND_NTS_ICD_STATUS: 703,

  /* NetDialer Interface DR_Path */
  ND_PDS: 800,
  ND_PDS_AGT_REQUEST_REGIST: 821,
  ND_PDS_AGT_REQUEST_CANCLE: 822,
  ND_PDS_DEFLECT_REQUEST: 823,

  ND_PDS_NOTIFY_RESV_INFO: 831,
  ND_PDS_NOTIFY_JOBEND: 832,
  // ND_PDS_SAVE_CALLRESULT: 833,
  ND_PDS_REQ_PREV_DIAL_INFO: 834,
  ND_PDS_REQ_RESV_DIAL_INFO: 835,
  ND_PDS_REQ_CAMPAIGN_LIST: 836
};



// WEBPACK FOOTER //
// ./src/util/call/neoWebRTC/neoWebRtcAPI/ndProtocol.js